import React, { useState, useEffect } from 'react'
import { Button, Col, DatePicker, Input, Popover, Row, Select, Form } from 'antd'
import { ControlOutlined, DownOutlined, SearchOutlined } from '@ant-design/icons'
import { getCompanyReport } from 'api/Dashboard/company_report'
import { getResultOperation } from 'api/MasterData/operation'
import { getResultSubOperation } from 'api/MasterData/subOperation'
import { getResultProjectGroup } from 'api/MasterData/projectGroup'
import { getResultProjectCategory } from 'api/MasterData/projectCategory'
import { getResultImpactType } from 'api/MasterData/impactType'
import moment from 'moment'
// import { keyBy } from 'lodash'
import {
  // getCompanyLink,
  getCompanyWithLink,
} from 'api/MasterData/userManagement'
import { getCookie, removeCookie, setCookie } from 'helper/cookie'
const { RangePicker } = DatePicker
const { Option } = Select
const initalState = {
  data: [],
  isLoading: true,
}

const HeaderFilter = (props) => {
  const {
    date_retro,
    current_date,
    role_exect,
    token,
    setDataFilter,
    setDateSearch,
    mainRoleUser,
  } = props
  const [dataCompany, setDataCompany] = useState(initalState.data)
  const [dataOperation, setDataOperation] = useState(initalState.data)
  const [dataSubOperation, setDataSubOperation] = useState(initalState.data)
  const [dataProjectGroup, setDataProjectGroup] = useState(initalState.data)
  const [dataProjectCat, setDataProjectCat] = useState(initalState.data)
  const [dataImpactType, setDataImpactType] = useState(initalState.data)
  const [companyId, setCompanyId] = useState()
  const [onSearch, setOnSearch] = useState(false)
  const [visible, setVisible] = useState(false)
  const [form] = Form.useForm()
  const [disable, setDisable] = useState({
    company: false,
    operation: true,
    suboperation: true,
    projectgroup: true,
    projectcat: true,
    impacttype: true,
  })
  const dataCookieFilter = getCookie('project_summary_filter')
  const getResultCompany = async (idCompany) => {
    await getCompanyReport({
      pathURL: mainRoleUser !== '1' ? 'company/report' : 'company?level=1',
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataCompany([])
          return true
        }
        if (status === 200) {
          // const joinLinkCompany = await fetchApiCompanyLink()
          // const mapping_CompanyLink = joinLinkCompany?.map((item) => {
          //   return {
          //     id: item.company_id,
          //     name_en: item.company_name_en,
          //     name_th: item.company_name_th,
          //   }
          // })
          const mapping_DefaultData = data?.map((item) => {
            return {
              id: item.id,
              name_en: item.name_en,
              name_th: item.name_th,
            }
          })
          const groupArrayCompany = [
            {
              id: 0,
              name_en: 'All Business',
              name_th: 'All Business',
            },
            ...mapping_DefaultData,
            // ...mapping_CompanyLink,
          ]
          setDataCompany(groupArrayCompany)
          let id = dataCookieFilter === undefined ? groupArrayCompany[0].id : idCompany
          getOperation(id)
          getProjectGroup(id)
          getImpactType(id)
          if (!dataCookieFilter) {
            setCompanyId(id)
          }
          setDisable((prevState) => ({
            ...prevState,
            // company: true,
            operation: false,
          }))
          if (!dataCookieFilter) {
            form.setFieldsValue({ company: id })
          }
        } else {
          return true
        }
      })
      .catch((error) => {
        setDataCompany([])
        console.error(error)
      })
  }
  const fetchApiCompanyWithLink = async () => {
    await getCompanyWithLink({
      token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataCompany([])
          return true
        }
        if (status === 200) {
          const mapping_CompanyLink = data?.map((item) => {
            return {
              id: item.id,
              name_en: item.name_en,
              name_th: item.name_th,
            }
          })
          const groupArrayCompany = [
            {
              id: 0,
              name_en: 'All Company',
              name_th: 'ทั้งหมด',
            },
            ...mapping_CompanyLink,
          ]
          setDataCompany(groupArrayCompany)
        }
      })
      .catch((error) => {
        setDataCompany([])
        console.error(error)
      })
  }

  const getOperation = async (company_id) => {
    await getResultOperation({
      token: token,
      level_id: company_id,
    })
      .then(async (response) => {
        const { status, data } = response
        if (status !== 200) {
          await setDataOperation([])
          return true
        }
        if (status === 200) {
          await setDataOperation(data)
        } else {
          return true
        }
      })
      .catch((error) => {
        setDataOperation([])
        console.error(error)
      })
  }
  const getSubOperation = async (company_id) => {
    await getResultSubOperation({
      token: token,
      level_id: company_id,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataSubOperation([])
          return true
        }
        if (status === 200) {
          setDataSubOperation(data)
        } else {
          setDataSubOperation([])
        }
      })
      .catch((error) => {
        setDataSubOperation([])
        console.error(error)
      })
  }
  const getProjectGroup = async (company_id) => {
    await getResultProjectGroup({
      token: token,
      company_id: company_id,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataProjectGroup([])
          return true
        }
        if (status === 200) {
          setDataProjectGroup(data)
        } else {
          setDataProjectGroup([])
        }
      })
      .catch((error) => {
        setDataProjectGroup([])
        console.error(error)
      })
  }

  const getProjectCategory = async (id, dataCompanyId) => {
    await getResultProjectCategory({
      token: token,
      project_group_id: id,
      company_id: dataCompanyId,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataProjectCat([])
          return true
        }
        if (status === 200) {
          setDataProjectCat(data)
        } else {
          setDataProjectCat([])
        }
      })
      .catch((error) => {
        setDataProjectCat([])
        console.error(error)
      })
  }
  const getImpactType = async (id) => {
    await getResultImpactType({
      token: token,
      company_id: id,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setDataImpactType([])
          return true
        }
        if (status === 200) {
          await setDataImpactType(data)
        } else {
          return true
        }
      })
      .catch((error) => {
        setDataImpactType([])
        console.error(error)
      })
  }
  useEffect(() => {
    if (!dataCookieFilter) {
      if (mainRoleUser === '1') {
        getResultCompany()
      } else {
        fetchApiCompanyWithLink()
      }
      var today = new Date()
      var datenow =
        today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
      var currentDate = moment(datenow).format('YYYY-MM-DD')
      const myArray = currentDate.split('-')
      let month = parseInt(myArray[1])
      if ([1, 2, 3].includes(month)) {
        // This is a quarter one January -> March
        var st_date = String(`${myArray[0]}-1-01`)
        var ed_date = String(`${myArray[0]}-3-31`)

        form.setFieldsValue({
          date: [moment(st_date, 'YYYY-MM-DD'), moment(ed_date, 'YYYY-MM-DD')],
        })
      } else if ([4, 5, 6].includes(month)) {
        // This is a quarter two April -> June
        var st_date = String(`${myArray[0]}-4-01`)
        var ed_date = String(`${myArray[0]}-6-30`)
        form.setFieldsValue({
          date: [moment(st_date, 'YYYY-MM-DD'), moment(ed_date, 'YYYY-MM-DD')],
        })
      } else if ([7, 8, 9].includes(month)) {
        // This is a quarter three July -> September
        var st_date = String(`${myArray[0]}-7-01`)
        var ed_date = String(`${myArray[0]}-9-30`)
        form.setFieldsValue({
          date: [moment(st_date, 'YYYY-MM-DD'), moment(ed_date, 'YYYY-MM-DD')],
        })
      } else if ([10, 11, 12].includes(month)) {
        //This is a quarter four October -> December
        var st_date = String(`${myArray[0]}-10-01`)
        var ed_date = String(`${myArray[0]}-12-31`)
        form.setFieldsValue({
          date: [moment(st_date, 'YYYY-MM-DD'), moment(ed_date, 'YYYY-MM-DD')],
        })
      }
    } else {
      if (mainRoleUser === '1') {
        const convertJsonDataCookieFilter = JSON.parse(dataCookieFilter)
        setCompanyId(convertJsonDataCookieFilter.company)
        getResultCompany(convertJsonDataCookieFilter.company)
      } else {
        fetchApiCompanyWithLink()
      }
      const convertJsonDataCookieFilter = JSON.parse(dataCookieFilter)

      const filterOptions = {
        company: convertJsonDataCookieFilter.company || undefined,
        operation: convertJsonDataCookieFilter.operation || undefined,
        sub_operation: convertJsonDataCookieFilter.sub_opearation || undefined,
        project_group: convertJsonDataCookieFilter.project_group || undefined,
        project_cat: convertJsonDataCookieFilter.project_cat || undefined,
      }

      Object.keys(filterOptions).forEach((key) => {
        onChangeSelect(filterOptions[key], key)
      })
      form.setFieldsValue({
        date:
          convertJsonDataCookieFilter?.date === undefined ||
            convertJsonDataCookieFilter?.date === null
            ? null
            : [
              moment(convertJsonDataCookieFilter?.date[0], 'YYYY-MM-DD'),
              moment(convertJsonDataCookieFilter?.date[1], 'YYYY-MM-DD'),
            ],
        company: convertJsonDataCookieFilter.company,
        operation: convertJsonDataCookieFilter.operation,
        sub_opearation: convertJsonDataCookieFilter.sub_opearation,
        project_group: convertJsonDataCookieFilter.project_group,
        project_cat: convertJsonDataCookieFilter.project_cat,
        impact_type: convertJsonDataCookieFilter.impact_type,
      })
    }
  }, [])

  const onChangeSelect = (val, type) => {
    if (type === 'company') {
      setCompanyId(val)
      getOperation(val)
      getProjectGroup(val)
      getImpactType(val)
      selectCompany()
      if (val !== undefined) {
        setDisable((prevState) => ({
          ...prevState,
          operation: false,
        }))
      }
    } else if (type === 'operation') {
      getSubOperation(val)
      selectOperation()
      if (val !== undefined) {
        setDisable((prevState) => ({
          ...prevState,
          suboperation: false,
        }))
      }
    } else if (type === 'sub_operation') {
      selectSubOperation()
      if (val !== undefined) {
        setDisable((prevState) => ({
          ...prevState,
          projectgroup: false,
        }))
      }
    } else if (type === 'project_group') {
      if (dataCookieFilter) {
        const convertJsonDataCookieFilter = JSON.parse(dataCookieFilter)
        getProjectCategory(val, convertJsonDataCookieFilter.company)
      } else {
        getProjectCategory(val, companyId)
      }

      selectProjectGroup()
      if (val !== undefined) {
        setDisable((prevState) => ({
          ...prevState,
          projectcat: false,
        }))
      }
    } else if (type === 'project_cat') {
      selectProjectCat()
      if (val !== undefined) {
        setDisable((prevState) => ({
          ...prevState,
          impacttype: false,
        }))
      }
    }
  }
  //company
  const selectCompany = () => {
    form.setFieldsValue({
      operation: null,
      sub_opearation: null,
      project_group: null,
      project_cat: null,
      impact_type: null,
    })
    setDisable((prevState) => ({
      ...prevState,
      operation: true,
      suboperation: true,
      projectgroup: true,
      projectcat: true,
      impacttype: true,
    }))
  }
  //operation
  const selectOperation = () => {
    form.setFieldsValue({
      sub_opearation: null,
      project_group: null,
      project_cat: null,
      impact_type: null,
    })
    setDisable((prevState) => ({
      ...prevState,
      suboperation: true,
      projectgroup: true,
      projectcat: true,
      impacttype: true,
    }))
  }
  //Project type
  const selectSubOperation = () => {
    form.setFieldsValue({
      project_group: null,
      project_cat: null,
      impact_type: null,
    })
    setDisable((prevState) => ({
      ...prevState,
      projectgroup: true,
      projectcat: true,
      impacttype: true,
    }))
  }
  //ProjectGroup
  const selectProjectGroup = () => {
    form.setFieldsValue({
      project_cat: null,
      impact_type: null,
    })
    setDisable((prevState) => ({
      ...prevState,
      projectcat: true,
      impacttype: true,
    }))
  }
  //ProjectCategory
  const selectProjectCat = () => {
    form.setFieldsValue({
      impact_type: null,
    })
    setDisable((prevState) => ({
      ...prevState,
      impacttype: true,
    }))
  }
  const onChangeDate = (date, type) => {
    const dataFormCookie = {
      date:
        date === undefined || date === null
          ? null
          : [moment(date[0]).format('YYYY-MM-DD'), moment(date[1]).format('YYYY-MM-DD')],
      company: 0,
    }
    if (date !== null) {
      if (type === 'main') {
        setDateSearch({
          date: [
            moment(date[0]).format('YYYY-MM-DD'),
            moment(date[1]).format('YYYY-MM-DD'),
          ],
        })
        setDataFilter('SearchDate')
      }
    }
    const expirationDate = new Date()
    expirationDate.setFullYear(expirationDate.getFullYear() + 1)
    setCookie('project_summary_filter', dataFormCookie, { expires: expirationDate })
  }
  const handleSearch = (val) => {
    if (val.company >= 1) {
      const dataCookie = {
        project: null,
        date: val?.date,
        company: [String(val?.company)],
        operation: [String(val?.operation)],
        sub_opearation: [String(val?.sub_opearation)],
        project_group: [String(val?.project_group)],
        impact_type: [String(val?.impact_type)],
        subproject_group_id: [String(val?.project_cat)],
        dataSortTopOrButtom: true,
        dataSortByType: '1',
      }
      setCookie('data_filter_form_summary', dataCookie)
    } else {
      const dataCookie = {
        project: null,
        company: [],
        operation: [],
        sub_opearation: [],
        project_group: [],
        impact_type: [],
        subproject_group_id: [],
        dataSortTopOrButtom: true,
        dataSortByType: '1',
      }
      setCookie('data_filter_form_summary', dataCookie)
    }

    if (
      val.company ||
      val.impact_type ||
      val.operation ||
      val.project_cat ||
      val.project_group ||
      val.sub_opearation
    ) {
      setOnSearch(true)
    } else {
      setOnSearch(false)
    }
    let arrayFilter = []
    Object.keys(val).map(function (key) {
      if (val[key] == null || val[key] == undefined) {
        arrayFilter.push({
          name: key,
          value: '',
        })
      } else {
        // const filterOptionCompany = dataCompany
        //   .filter((item) => item.id !== 0)
        //   .map((newdata) => newdata.id)

        if (key === 'company') {
          arrayFilter.push({
            name: key,
            // value: val[key] == 0 ? filterOptionCompany.join(',') : String(val[key]),
            value: val[key] == 0 ? '' : String(val[key]),
          })
          return
        }
        arrayFilter.push({
          name: key,
          value: val[key],
        })
      }
    })

    setDataFilter(arrayFilter)
    setVisible(false)
  }
  const selectFilter = () => {
    return (
      <Col className='container-select'>
        <Row style={{ alignItems: 'center' }}>
          <ControlOutlined className='controlOutlined' />
          <h3>Advanced Filter</h3>
        </Row>

        <Form.Item name='date' className='size-form'>
          <RangePicker
            onChange={onChangeDate}
            placeholder={['Start kick off date', ' End kick off date']}
            size='large'
            allowClear={false}
          />
        </Form.Item>
        <Form.Item className='disable-page size-form' id='company' name='company'>
          <Select
            id='company'
            name='company'
            size='large'
            placeholder='Company'
            showSearch
            filterOption={(input, option) =>
              option?.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
            }
            onChange={(e) => onChangeSelect(e, 'company')}
            disabled={disable.company}
            allowClear
            style={{ maxWidth: 328 }}
          >
            {dataCompany?.map((item) => (
              <Option value={item.id} key={item.id}>
                {item.name_th}
              </Option>
            ))}
          </Select>
        </Form.Item>

        {role_exect && (
          <Form.Item className='size-form' id='operation' name='operation'>
            <Select
              id='operation'
              name='operation'
              size='large'
              placeholder='Operation'
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              onChange={(e) => onChangeSelect(e, 'operation')}
              allowClear
              disabled={disable.operation}
              style={{ maxWidth: 328 }}
            >
              {dataOperation?.map((item) => (
                <Option value={item.id} key={item.id}>
                  {item.name_th}
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}
        {role_exect && (
          <Form.Item className='size-form' id='sub_operation' name='sub_opearation'>
            <Select
              id='sub_operation'
              name='sub_operation'
              size='large'
              placeholder='Project type'
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              onChange={(e) => onChangeSelect(e, 'sub_operation')}
              allowClear
              disabled={disable.suboperation}
              style={{ maxWidth: 328 }}
            >
              {dataSubOperation?.map((item) => (
                <Option value={item.id} key={item.id}>
                  {item.name_th}
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}

        {role_exect && (
          <Form.Item className='size-form' id='project_group' name='project_group'>
            <Select
              id='project_group'
              name='project_group'
              size='large'
              placeholder='Strategic Perspective'
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              onChange={(e) => onChangeSelect(e, 'project_group')}
              allowClear
              disabled={disable.projectgroup}
              style={{ maxWidth: 328 }}
            >
              {dataProjectGroup?.map((item) => (
                <Option value={item.id} key={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}

        {role_exect && (
          <Form.Item className='size-form' id='project_cat' name='project_cat'>
            <Select
              id='project_cat'
              name='project_cat'
              size='large'
              placeholder='Strategic Direction'
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              onChange={(e) => onChangeSelect(e, 'project_cat')}
              allowClear
              disabled={disable.projectcat}
              style={{ maxWidth: 328 }}
            >
              {dataProjectCat?.map((item) => (
                <Option value={item.id} key={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}

        {role_exect && (
          <Form.Item className='size-form' id='impact_type' name='impact_type'>
            <Select
              id='impact_type'
              name='impact_type'
              size='large'
              placeholder='Stage'
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              onChange={(e) => onChangeSelect(e, 'impact_type')}
              allowClear
              disabled={disable.impacttype}
              style={{ maxWidth: 328 }}
            >
              {dataImpactType?.map((item) => (
                <Option value={item.id} key={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}

        <Row className='footer-filter'>
          <Button
            className='BTN_Previous'
            onClick={() => {
              form.setFieldsValue({
                date: [
                  moment(date_retro, 'YYYY-MM-DD'),
                  moment(current_date, 'YYYY-MM-DD'),
                ],
                company: dataCompany?.length > 1 ? null : dataCompany[0]?.id,
                operation: null,
                sub_opearation: null,
                project_group: null,
                project_cat: null,
                impact_type: null,
              }),
                setDisable((prevState) => ({
                  ...prevState,
                  operation: dataCompany.length > 1 ? true : false,
                  suboperation: true,
                  projectgroup: true,
                  projectcat: true,
                  impacttype: true,
                })),
                setOnSearch(false),
                form.submit()
              removeCookie('project_summary_filter')
            }}
          >
            Reset
          </Button>
          <Button
            icon={<SearchOutlined className='searchOutlined' />}
            className='BTN_Next'
            onClick={() => {
              const dataFormCookie = {
                date: [
                  form.getFieldValue('date') === undefined ||
                    form.getFieldValue('date') === null
                    ? null
                    : moment(form.getFieldValue('date')[0]).format('YYYY-MM-DD'),
                  moment(form.getFieldValue('date')[1]).format('YYYY-MM-DD'),
                ],
                company: form.getFieldValue('company'),
                impact_type: form.getFieldValue('impact_type'),
                operation: form.getFieldValue('operation'),
                project_cat: form.getFieldValue('project_cat'),
                project_group: form.getFieldValue('project_group'),
                sub_opearation: form.getFieldValue('sub_opearation'),
              }
              form.submit()
              const expirationDate = new Date()
              expirationDate.setFullYear(expirationDate.getFullYear() + 1)
              setCookie('project_summary_filter', dataFormCookie, {
                expires: expirationDate,
              })
            }}
          >
            Search
          </Button>
        </Row>
      </Col>
    )
  }

  return (
    <div className='container-filter'>
      <Form onFinish={handleSearch} form={form}>
        <Row className='container-rows-filter' style={{ width: '100%' }}>
          <Form.Item style={{ width: '100%' }} name='date'>
            <RangePicker
              className='range-picker'
              onChange={(e) => onChangeDate(e, 'main')}
              placeholder={['Start kick off date', ' End kick off date']}
              size='large'
              allowClear={false}
            />
          </Form.Item>
          <Popover
            arrowContent={true}
            content={selectFilter()}
            trigger='click'
            visible={visible}
            placement='bottomRight'
          >
            <Button
              id='advanceFilter'
              icon={<ControlOutlined style={{ color: '#fff' }} />}
              className={'btn_Secondary2'}
              onClick={() => setVisible(!visible)}
              style={{ minWidth: 'unset' }}
            >
              Advanced Filter
            </Button>
          </Popover>
        </Row>
      </Form>
    </div>
  )
}

export default HeaderFilter
